
import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { logger } from '~/core/logger/logger';

async function main() {
    startTransition(() => {
        hydrateRoot(
            document,
                <StrictMode>
                    <HydratedRouter />
                </StrictMode>
        );
    });
}

main().catch((error) => logger.error({ error }, 'Failed to hydrate client application'));
